define('views/content/periodic_licenses',['require','views/base/list_page_view','moment','views/components/periodic_license/periodic_licenses','collections/customer_products','text!templates/content/periodic_licenses.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');
    var moment = require('moment');

    var PeriodicLicensesView = require('views/components/periodic_license/periodic_licenses');
    var CustomerProductssCollection = require('collections/customer_products');

    var temp = require("text!templates/content/periodic_licenses.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'customer-page',
        titleKey: 'periodic_licenses',

        setCollection: function () {
            var now = new Date();
            var timeLimit = new Date(now.getFullYear() + 3, now.getMonth(), now.getDate());
            this.collection = new CustomerProductssCollection([], {
                parameters: {
                    'payment_schedule_in': '2,3',
                    'end_time_lte': moment(timeLimit).format('YYYY-MM-DD'),
                    'extendable': true
                }
            });
            this.collection.changeOrdering('end_time');
        },

        onRender: function() {
            this.ListContainer.show(new PeriodicLicensesView({
                collection: this.collection
            }));
        }

    });
});
